module.exports = __webpack_public_path__ + "static/media/report.dec9372b.png";